import { Action, isRejected } from "@reduxjs/toolkit";

interface RejectedAction extends Action {
  error?: {
    message?: string;
    code?: string;
  };
}

const isRejectedAction = (action: Action): action is RejectedAction =>
  "error" in action && typeof action.error === "object";

export const isForbidden = (action: Action): boolean => {
  if (isRejected(action) && isRejectedAction(action)) {
    return action.error.message === "Forbidden" || action.error.code === "403";
  }
  return false;
};
